<svg
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="block"
>
  <path
    d="M10 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V10.8333C2.5 11.6083 2.5 11.9958 2.58519 12.3137C2.81635 13.1764 3.49022 13.8503 4.35295 14.0815C4.67087 14.1667 5.05836 14.1667 5.83333 14.1667V16.9463C5.83333 17.3903 5.83333 17.6123 5.92436 17.7263C6.00352 17.8255 6.12356 17.8832 6.25045 17.8831C6.39636 17.8829 6.56973 17.7442 6.91646 17.4668L9.73768 15.0432C10.1438 14.7183 10.3468 14.5559 10.5729 14.4404C10.7735 14.3379 10.987 14.263 11.2077 14.2177C11.4564 14.1667 11.7164 14.1667 12.2365 14.1667H13.5C14.9001 14.1667 15.6002 14.1667 16.135 13.8942C16.6054 13.6545 16.9878 13.272 17.2275 12.8016C17.5 12.2669 17.5 11.5668 17.5 10.1667V10"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M15.8333 6.66667V1.66667M13.3333 4.16667H18.3333"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M6.25 6.66667H10M6.25 10H12.0833"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
